module.exports = __webpack_public_path__ + "components/star-rating/static/white/5-a9b23dc471f31e5fe03f848fb9d8bf93.svg";